/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Preview_TasksInputs */

const en_mk_preview_tasks = /** @type {(inputs: Mk_Preview_TasksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tasks`)
};

const id_mk_preview_tasks = /** @type {(inputs: Mk_Preview_TasksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tugas`)
};

/**
* | output |
* | --- |
* | "Tasks" |
*
* @param {Mk_Preview_TasksInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_preview_tasks = /** @type {((inputs?: Mk_Preview_TasksInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Preview_TasksInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_preview_tasks(inputs)
	return en_mk_preview_tasks(inputs)
});